import React from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { ContentVideoLayout } from '../VideoBlock.types';
import bem from '../../../lib/bemUtils/bem';
import { ContentBlockHeadline } from '../../../_lib/components/ContentBlockHeadline';
import { isNotNullOrUndefined } from '../../../lib/typeGuards';
import { VideoWithMetaInfoType, VideoWithMetaInfo } from '../../../_lib/components/Video/VideoWithMetaInfoType';

type ContentVideo = {
  title: string;
  copyright: string;
  layout: ContentVideoLayout;
} & VideoWithMetaInfoType;

const mapLayoutToModifier = (layout: ContentVideoLayout) => {
  switch (layout) {
    case 'largeVideoDescriptionBelow':
      return 'large-video-description-below';
    case 'mediumVideoDescriptionBelow':
      return 'medium-video-description-below';
    case 'smallVideoDescriptionBelow':
      return 'small-video-description-below';
    case 'mediumVideoDescriptionRight':
      return 'medium-video-description-right';
    case 'smallVideoDescriptionRight':
      return 'small-video-description-right';
    default:
      return undefined;
  }
};

export function ContentVideo({ title, source, contentType, captionsFile, caption, copyright, layout }: ContentVideo) {
  const { uuid } = useBlockContext();

  if (!source) {
    return null;
  }

  const modifiers = [];

  modifiers.push(mapLayoutToModifier(layout));

  return (
    <div className={bem('content-video', modifiers.filter(isNotNullOrUndefined))}>
      <ContentBlockHeadline
        // header is <h2>
        // editModeInfo.active blockinteraction is <h3>
        // depending on them, hierarchy is <h2>, <h3> or <h4>
        hierarchy={2}
        title={title}
      />
      <VideoWithMetaInfo
        caption={caption}
        copyright={copyright}
        source={source}
        contentType={contentType}
        captionsFile={captionsFile}
        ariaDescribedby={`content-video-${uuid}`}
      />
    </div>
  );
}

export const VideoDefaultView = asView(ContentVideo);
